import { render, staticRenderFns } from "./SearchDocument.vue?vue&type=template&id=3e1659e4&"
import script from "./SearchDocument.vue?vue&type=script&lang=ts&"
export * from "./SearchDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports